<ct-lib-modal
  [small]="true"
  [closeable]="!isUpdating() && paymentCheckout()?.loading() !== true"
  #modal
  (onClose)="backToSelection()"
  [label]="modalTitleKey() | transloco"
  [hideFooter]="paymentCheckout()?.loading() === true"
  [footer]="agentsBookingModalFooter"
>
  <div class="agents-booking-modal" [class.is-busy]="isUpdating()">
    @if (isPaymentMethodStep()) {
      <app-payment-method-choice
        #paymentMethodChoice
        [busy]="bookingInProgress()"
      />
    } @else if (!isPaymentStep()) {
      @if (
        hasExistingAgentsSubscription() && agentsSubscription();
        as current
      ) {
        <div class="current-plan" aria-live="polite">
          <p class="current-plan-label">
            {{
              'company-tool.snippets.agents-booking-modal.current-plan-label'
                | transloco
            }}
          </p>
          <p class="current-plan-name">{{ current.name }}</p>
          <p class="current-plan-meta">
            {{
              'company-tool.snippets.agents-booking-modal.current-plan-meta'
                | transloco
                  : {
                      count: current.maxAgents ?? 0,
                      interval:
                        (current.interval === 'year'
                          ? 'company-tool.snippets.agents-booking-modal.interval-year'
                          : 'company-tool.snippets.agents-booking-modal.interval-month'
                        ) | transloco,
                    }
            }}
          </p>
        </div>
      }

      @if (scheduledAgentsChange(); as scheduled) {
        <ct-lib-info-banner type="info" class="schedule-banner">
          <div class="schedule-banner-content">
            <p
              [innerHTML]="
                'company-tool.snippets.agents-booking-modal.scheduled-change'
                  | transloco
                    : {
                        date: scheduled.changeAt | date: 'longDate',
                        plan: scheduled.toPlanName || '—',
                      }
              "
            ></p>
            @if (canCancelSchedule()) {
              <app-button
                variant="white-grey"
                [loading]="cancelScheduleBusy()"
                [disabled]="isUpdating()"
                (click)="openCancelScheduleConfirm()"
              >
                {{
                  'company-tool.snippets.agents-booking-modal.cancel-schedule'
                    | transloco
                }}
              </app-button>
            }
          </div>
        </ct-lib-info-banner>
      }

      <ct-lib-segmented-control
        class="billing-interval-control mb-3"
        [autowidth]="false"
        [items]="billingIntervalOptions()"
        [selectedValue]="billingInterval()"
        (valueChange)="setBillingInterval($event)"
      ></ct-lib-segmented-control>

      <app-agents-plan-selector
        [products]="selfBookingAddons()"
        [loaded]="selfBookingAddonsLoaded()"
        [billingInterval]="billingInterval()"
        [disabled]="isUpdating()"
        [isCustomCurrent]="isCustomCurrent()"
        [currentPackagePriceId]="currentPackagePriceId()"
        [(selectedOption)]="selectedOptionValue"
        [(customAgentCount)]="customAgentCount"
      />

      @if (isUpdating()) {
        <div class="booking-overlay" aria-busy="true" aria-live="polite">
          <ct-lib-spinner [size]="40"></ct-lib-spinner>
          <p>
            {{
              'company-tool.snippets.agents-booking-modal.updating' | transloco
            }}
          </p>
        </div>
      }
    } @else {
      <app-payment-checkout
        (paymentCompleted)="onPaymentCompletedFunction()()"
        (paymentFailed)="onPaymentFailed()"
      ></app-payment-checkout>
    }
  </div>
</ct-lib-modal>

<ng-template #agentsBookingModalFooter>
  @if (isPaymentStep()) {
    <app-button variant="white-grey" (click)="backToSelection()">
      {{ 'company-tool.snippets.agents-booking-modal.back' | transloco }}
    </app-button>
  } @else if (isPaymentMethodStep()) {
    <app-button variant="white-grey" (click)="backToSelection()">
      {{ 'company-tool.snippets.payment-method-choice.back' | transloco }}
    </app-button>
    <app-button
      [loading]="bookingInProgress()"
      [disabled]="bookingInProgress()"
      (click)="confirmPaymentMethod()"
    >
      {{ 'company-tool.snippets.payment-method-choice.continue' | transloco }}
    </app-button>
  } @else {
    <app-button
      [disabled]="!canBook()"
      [loading]="bookingInProgress()"
      (click)="bookSelected()"
    >
      {{ confirmLabelKey() | transloco }}
    </app-button>
  }
</ng-template>

<app-invoice-booking-confirm-modal
  #invoiceConfirm
  (confirmed)="onInvoiceBookingConfirmed()"
></app-invoice-booking-confirm-modal>

<ct-lib-confirm-modal
  #downgradeConfirmModal
  [disableConfirmButton]="isUpdating()"
  (onConfirm)="confirmDowngrade()"
  [label]="
    'company-tool.snippets.agents-booking-modal.downgrade-confirm.title'
      | transloco
  "
>
  {{
    'company-tool.snippets.agents-booking-modal.downgrade-confirm.text'
      | transloco
        : {
            date: downgradeEffectiveDate() | date: 'longDate',
            plan:
              selectedAddon()?.product?.name ||
              singleSeatAddon()?.product?.name ||
              '',
          }
  }}
</ct-lib-confirm-modal>

<ct-lib-confirm-modal
  #cancelScheduleConfirmModal
  [disableConfirmButton]="cancelScheduleBusy()"
  (onConfirm)="cancelScheduledChange()"
  [label]="
    'company-tool.snippets.agents-booking-modal.cancel-schedule-confirm.title'
      | transloco
  "
>
  {{
    'company-tool.snippets.agents-booking-modal.cancel-schedule-confirm.text'
      | transloco
        : {
            date: (scheduledAgentsChange()?.changeAt | date: 'longDate') || '—',
          }
  }}
</ct-lib-confirm-modal>
